import React from "react";
import { Modal } from "react-bootstrap";

interface ImagePreviewModalProps {
  show: boolean;
  onClose: () => void;
  imageSrc: string;
  title?: string;
}

const ImagePreviewModal: React.FC<ImagePreviewModalProps> = ({
  show,
  onClose,
  imageSrc,
  title = "Image Preview",
}) => {
  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center p-2">
        <img
          src={imageSrc}
          alt={title}
          style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ImagePreviewModal;
